import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IInternalContact, internalContactsManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';

const INTERNAL_CONTACT_MODULE = 'internalContact';

const dataObjectModule = getDataObjectsModule<IInternalContact>(internalContactsManager, 3);
const searchModule = getSearchModule<IInternalContact>(internalContactsManager);

const state = { matches: new Map() };

const internalContactModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions, state, getters, mutations });
store.registerModule(INTERNAL_CONTACT_MODULE, internalContactModuleInstance);

export { INTERNAL_CONTACT_MODULE };
